export default ({...props}) => {
  const {size, space} = props.theme
  return `
    display: flex;
    width: ${size(12.5)}%;
    padding: 0 ${space(2)}px;
    align-items: flex-start;
    justify-content: flex-end;
    & > * {
       width: 50%;
    }

    & .status-wrapper > p {
       text-transform: Capitalize;
       margin: 0;
       &.case-inherit {
         text-transform: inherit;
       }
    }
    & div.MuiBox-root.instruction-wrapper p.MuiTypography-body1[ahd_type="sData"] {
        display:block;
        word-wrap: break-word;
    }
   
    @media screen and (max-width: 891px){
       & {
            flex-direction: column;
            gap: ${space(0.625)}px;

            & > * {
               width: ${size(12.5)}%;
            }
       } 
    }

    @media screen and (max-width: 476px){
        & {
            gap: ${space(1.25)}px;
        }
    }
    `
}
